export default function NotFoundPage() {
  return <div>Not found</div>;
}
